import { configureRequest } from '../../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  GetLockerBoxesErrorResponse,
  GetLockerBoxesRequest,
  GetLockerBoxesSuccessResponse
} from './getLockerBoxes.types'

export const getLockerBoxesApi = async (request: GetLockerBoxesRequest): Promise<GetLockerBoxesSuccessResponse> => {
  const response = await configureRequest({
    url: urls.admin.getLockerBoxes,
    method: 'GET',
    params: Object.keys(request).length > 0 ? (request as Record<string, string | number | string[]>) : undefined,
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as GetLockerBoxesSuccessResponse
  } else {
    throw response as GetLockerBoxesErrorResponse
  }
}

export default getLockerBoxesApi
